export const getters = {
  systemStocks: state => state.stocks
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/stocks/getters.js